'use client';

import { Button } from '@tuic/web-compositions/core/Button';
import { Pictogram } from '@tuic/web-compositions/core/Pictogram';

import type { ComponentBlock } from '@modules/prism-client/types/types';
import type { PictogramName } from '@tuic/web-compositions/core/Pictogram';
import type { ReactNode } from 'react';

export type ManifestFormSuccessBlockProps = {
  title?: ReactNode;
  paragraph?: ReactNode;
  pictogram?: PictogramName;
  pinLabel?: string;
  pin?: string;
  backToOverviewLabel?: string;
  backToOverviewHref?: string;
};

export const ManifestFormSuccessBlock: ComponentBlock<
  ManifestFormSuccessBlockProps
> = ({ data }) => {
  if (!data) return null;

  const {
    title,
    paragraph,
    pictogram,
    pinLabel,
    pin,
    backToOverviewLabel,
    backToOverviewHref,
  } = data;

  return (
    <div className="flex flex-col items-center gap-6 text-center text-marine-high-emphasis">
      {pictogram && (
        <Pictogram name={pictogram} className="bg-ocean-60 rounded-full p-5" />
      )}

      {title && <h1 className="headline-lg">{title}</h1>}

      {paragraph && <div className="text-lg">{paragraph}</div>}

      {pin && (
        <div className="flex items-center gap-3 rounded-lg bg-ocean-10 px-6 py-3">
          {pinLabel && (
            <span className="text-lg font-semibold">{pinLabel}</span>
          )}
          <span className="text-lg font-semibold tracking-widest">{pin}</span>
        </div>
      )}

      {backToOverviewHref && backToOverviewLabel && (
        <Button asChild>
          <a href={backToOverviewHref}>{backToOverviewLabel}</a>
        </Button>
      )}
    </div>
  );
};
